import { NextSeo } from 'next-seo'
import type { RichTextField } from '@prismicio/client'
import SubscriptionPlanCard from '@components/subscription/SubscriptionPlanCard'
import subscriptionListing from '../../data/subscription-listing.json'

const placeholderImage = '/images/subscription-box-placeholder.png' // Update with real image path

interface SubscriptionPlanCardSlice {
	id?: string
	slice_type: string
	primary?: {
		main_image?: { url: string }
		subscription_plan_title?: RichTextField
		subscription_plan_subtitle?: RichTextField
		max_box_value?: number
		starting_price?: number
		delivery_frequency?: string
		cta_text?: string
		subscription_detail_page?: {
			uid?: string
		}
	}
	items?: { feature: string }[]
}

export default function SubscriptionsPage() {
	const title = subscriptionListing.title?.[0]?.text || 'Choose Your Subscription Plan'
	const subtitle = subscriptionListing.subtitle?.[0]?.text || ''
	const cards: SubscriptionPlanCardSlice[] = Array.isArray(subscriptionListing.body)
		? (subscriptionListing.body as unknown as SubscriptionPlanCardSlice[]).filter(
				(slice: SubscriptionPlanCardSlice) => slice.slice_type === 'subscription_plan_card'
			)
		: []

	return (
		<>
			<NextSeo title={`${title} | Birchbox`} description={subtitle} />
			<div className="bg-bbx-pearl">
				<div className="container mx-auto px-4 py-16 pb-40">
					<div className="mb-12 md:mb-20">
						<h1 className="text-3xl md:text-4xl font-medium font-serif mb-2 text-center">
							{title}
						</h1>
						{subtitle && <p className="text-xl md:text-2xl text-center font-sans">{subtitle}</p>}
					</div>
					{/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-16 justify-center"> */}
					<div className="flex flex-col md:flex-row gap-16 justify-center">
						{cards.map((card, idx) => {
							const primary = card.primary || {}
							const features = Array.isArray(card.items)
								? card.items.map((item) => ({ text: item.feature, key: item.feature }))
								: []
							return (
								<SubscriptionPlanCard
									key={card.id || idx}
									imageUrl={card.primary?.main_image?.url || placeholderImage}
									badgeText={primary.max_box_value ? 'Up To A' : undefined}
									badgeValue={primary.max_box_value}
									title={primary.subscription_plan_title as RichTextField}
									subtitle={primary.subscription_plan_subtitle as RichTextField}
									deliveryFrequency={primary.delivery_frequency || ''}
									features={features}
									price={primary.starting_price ? `$${primary.starting_price}` : ''}
									priceSubtext={primary.starting_price ? '/Per Box' : ''}
									ctaText={primary.cta_text || 'Choose This Box'}
									href={`/subscriptions/${primary.subscription_detail_page?.uid}`}
								/>
							)
						})}
					</div>
				</div>
			</div>
		</>
	)
}
